import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { parselinkConfigurator } from './helpers/helpers.js';
import { useBloomreachPageModels } from './use-bloomreach-page-models.js';

const useBloomreachCartConfiguration = ()=>{
    const page = useBrPageContext();
    const pageModels = useBloomreachPageModels();
    const cartConfigurationContent = getBrPageContent(page, pageModels === null || pageModels === void 0 ? void 0 : pageModels.cartConfiguration);
    if (!cartConfigurationContent) {
        var ref;
        console.warn(`Cannot find main content for Cart Configuration. Got: ${cartConfigurationContent} for $ref: ${pageModels === null || pageModels === void 0 ? void 0 : (ref = pageModels.cartConfiguration) === null || ref === void 0 ? void 0 : ref.$ref}`);
        return undefined;
    }
    const { title: title1 , description , linkConfigurator1 , linkConfigurator2 , policyItem  } = cartConfigurationContent;
    const firstLink = parselinkConfigurator(linkConfigurator1, page);
    const secondLink = parselinkConfigurator(linkConfigurator2, page);
    const policyItems = policyItem && (policyItem === null || policyItem === void 0 ? void 0 : policyItem.length) > 0 ? policyItem === null || policyItem === void 0 ? void 0 : policyItem.map(({ text , url , popupConfig: { content , title  } , icon  })=>({
            text,
            url,
            popupConfig: {
                content,
                title
            },
            icon
        })
    ) : undefined;
    return {
        title: title1,
        description,
        firstLink,
        secondLink,
        policyItems
    };
};

export { useBloomreachCartConfiguration };
//# sourceMappingURL=use-bloomreach-cart-configuration.js.map
